var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#007CB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 25C10.2239 25 10 24.7762 10 24.5V15.5C10 15.2239 10.2239 15 10.5 15L14.28 15L19.6314 9.16216C19.7647 9.01676 19.971 8.9633 20.1581 9.02568C21.3405 9.41982 22 10.0793 22 11C22 11.6472 21.5656 12.5461 20.6972 13.7542L20.5178 14H22.5754C22.9083 14 23.2393 14.0486 23.5582 14.1443C25.3673 14.687 26.3939 16.5936 25.8512 18.4027L24.6203 22.5057C24.1762 23.9862 22.8135 25 21.2679 25H10.5ZM13.999 16L11 16V24L13.999 24V16ZM20.1412 10.0859L15 15.693V24L21.2679 24C22.3719 24 23.3452 23.2758 23.6625 22.2184L24.8934 18.1154C25.2774 16.8352 24.551 15.4861 23.2708 15.1021C23.0452 15.0344 22.811 15 22.5754 15H19.5C19.0807 15 18.8477 14.5151 19.1096 14.1877L19.4688 13.7293C20.4899 12.3973 21 11.4588 21 11C21 10.6419 20.7435 10.3381 20.1412 10.0859Z",
    fill: "#007CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.5ebe5a8e11aec46c71222981c6d3809a.svg";
export { ForwardRef as ReactComponent };